/* eslint-disable sort-keys */
export type SupportedLanguageCode = (typeof supportedLanguageCodes)[number];

export type SupportedLanguage = {
  label: string;
  value: SupportedLanguageCode;
};

/**
 * Order matters here for dialects: If a dialect is not supported, locale detection
 * will go down the list in order looking for another dialect of the same language
 * and then use the first one it finds.
 *
 * Eg if the user's locale is en-CA, but we don't support that, it'll look for
 * the first en locale in the supported languages list.
 */
export const supportedLanguageCodes = [
  "ar",
  "cs",
  "da",
  "de",
  "el",
  "en-GB",
  "en-US",
  "es",
  "fi",
  "fr",
  "hu",
  "it",
  "ja",
  "nb",
  "nl",
  "pl",
  "pt",
  "ro",
  "sv",
  "zh",
] as const;

const supportedLanguageLabels: Record<SupportedLanguageCode, string> = {
  "en-GB": "English (GB)",
  "en-US": "English (US)",
  ar: "عربي",
  cs: "Čeština",
  da: "Dansk",
  de: "Deutsch",
  el: "Ελληνικά",
  es: "Español",
  fi: "Suomi",
  fr: "Français",
  hu: "Magyar",
  it: "Italiano",
  ja: "日本語",
  nb: "Norsk",
  nl: "Nederlands",
  pl: "Polski",
  pt: "Português",
  ro: "Românește",
  sv: "Svenska",
  zh: "中文",
};

export const supportedLanguages: SupportedLanguage[] =
  supportedLanguageCodes.map((code) => ({
    label: supportedLanguageLabels[code],
    value: code,
  }));

export const isSupportedLanguageCode = (
  code: string,
): code is SupportedLanguageCode => {
  const codesForComparison: string[] = [...supportedLanguageCodes];
  return codesForComparison.includes(code);
};
